import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

/** Read-mode chip for an in-grid single select. The chevron means the cell opens a menu. */
export default function SelectableCell({ value }) {
    const label = value ? String(value) : "Select";
    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 2,
                maxWidth: "100%",
                height: 24,
                padding: "0 4px 0 8px",
                borderRadius: 8,
                border: "1px solid #cbd5e1",
                background: value ? "#f8fafc" : "#ffffff",
                color: value ? "#1c2430" : "#94a3b8",
                fontSize: 12,
                fontWeight: 600,
                lineHeight: "24px",
                cursor: "pointer",
            }}
        >
            <span
                style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                }}
            >
                {label}
            </span>
            <KeyboardArrowDownRoundedIcon sx={{ fontSize: 18, color: "#64748b", flexShrink: 0 }} />
        </span>
    );
}

export function openSelectableCell(params, fields) {
    if (!fields.includes(params.field)) return;
    const mode = params.api.getCellMode(params.id, params.field);
    if (mode === "edit") return;
    params.api.startCellEditMode({ id: params.id, field: params.field });
}
